export const pluralize = (number: number, text: string[]): string => {
  let n = Math.abs(number)
  n %= 100
  if (n >= 5 && n <= 20) {
    return text[2]
  }
  n %= 10
  if (n === 1) {
    return text[0]
  }
  if (n >= 2 && n <= 4) {
    return text[1]
  }
  return text[2]
}
